export const prefix = process.env.NODE_ENV === 'development' ? `https://www.sydev.info` : ``
// export const prefix = process.env.NODE_ENV === 'development' ? `https://www.shenyun.com` : ``
export default Object.freeze({
  redirect: `${prefix}/event/ajax-citypage-redirect?force=1`,
  nearByCitiesAPI: `/event/ajax-nearby-cities?json=1`,
  getLatLongAPI: `/event/ajax-get-lat-long-by-address?address=`,
  getAPI: `/api-home/get-api`,
  getContent: `/assets/data/about_content.json?v=001`,
  getEventTooltip: `${prefix}/tickets/ajax-get-event-tooltip/eid/`,
  getFullList: `${prefix}/tickets/get-full-list/json/1`,
  getNotification: `${prefix}/tickets/ajax-notification/json/1`,
  group: 'ca',
  loginLangCode: 'da',
  currentPage: 'groupPage',//homePage cityPage, groupPage
})

// export default {
//   randomAPI:
//     'https://www.random.org/integers/?num=1&min=1&max=99&col=1&base=10&format=plain&rnd=new',
//   redirect:
//     `${prefix}/event/ajax-citypage-redirect?force=1`,
// }
